import { request } from '../request';

/**
 * Login
 * 
 * If the return type is JSON, there is no need to consider the type parameters of the request<>
 * 
 * @param userName User name
 * @param password Password
 */
export function fetchLogin(userName: string, password: string) {
  return request<Api.Auth.LoginToken>({
    url: '/auth/login',
    method: 'post',
    data: {
      userName,
      password
    }
  });
}

/** Forgot password — reset via email (public, no login required) */
export function fetchForgotPassword(email: string) {
  return request({
    url: '/auth/forgotPassword',
    method: 'post',
    data: {
      email
    }
  });
}

/** Get user info */
export function fetchGetUserInfo() {
  return request<Api.Auth.UserInfo>({ url: '/auth/getUserInfo' });
}

/** Get current user's subscription notifications */
export function fetchGetNotifications() {
  return request<Api.Auth.Notifications>({ url: '/auth/getNotifications' });
}

/**
 * Refresh token
 *
 * @param refreshToken Refresh token
 */
export function fetchRefreshToken(refreshToken: string) {
  return request<Api.Auth.LoginToken>({
    url: '/auth/refreshToken',
    method: 'post',
    data: {
      refreshToken
    }
  });
}

/** Update current user data source preference */
export function updateDataSourcePref(pref: string | null) {
  return request({
    url: '/auth/data-source-pref',
    method: 'put',
    data: { value: pref }
  });
}

/**
 * return custom backend error
 *
 * @param code error code
 * @param msg error message
 */
export function fetchCustomBackendError(code: string, msg: string) {
  return request({ url: '/auth/error', params: { code, msg } });
}
